const dev = {
  REACT_APP_ID: process.env.REACT_APP_STAGING_ID,
  REACT_APP_BUILD_ENV: process.env.REACT_APP_BUILD_ENV,
};

const prod = {
  REACT_APP_ID: process.env.REACT_APP_PRODUCTION_ID,
  REACT_APP_BUILD_ENV: process.env.REACT_APP_BUILD_ENV,
};

export const config = process.env.REACT_APP_BUILD_ENV === 'production' ? prod : dev;
